module.exports = __webpack_public_path__ + "img/BlinkArt_Sword14_Yellow.f7a92b58.png";